import { OBJECT_TYPE } from '@/common/constants';
import { BaseElementObject } from './base';

export class GroupElementObject extends BaseElementObject {
  type = OBJECT_TYPE.MULTI_OBJECT;
  objects = [];
  /**
   * @param {GroupElementObject} props
   */
  constructor(props) {
    super(props);
    this._set(props);
    this.coord.rotation = 0;
  }
}
